import React from 'react'
import { DetailsViewWrapper, HeaderContent } from '../../general'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { ExtensionTypes, ExtensionDetailsProps } from '../../../types'
import FooterContent from './helpers/FooterContent'
import LuoxEnergyIconSvg from 'src/Libs/installation-extensions/resources/LuoxEnergySvg'
import { useTheme } from '@mui/material'
import { isFlowTheme } from 'src/Libs/utils/theme-helpers'

/**
 * Gives a detailed description of the luox marketing extension. Also allows to redirect to the partner.
 */
const LuoxDynamicTariffDetails: React.FC<ExtensionDetailsProps> = ({ extensionState, isLoading, hasActiveTariff, onClose, place = 0 }) => {
  const { t } = useCustomTranslation()
  const theme = useTheme()
  const description = isFlowTheme
    ? t('installation-extensions.luox-dynamic-tariff.modal.description.flow')
    : t('installation-extensions.luox-dynamic-tariff.modal.description')

  const contractStateProps = {
    contractState: extensionState,
    isLoading,
  }
  return (
    <DetailsViewWrapper
      extensionType={ExtensionTypes.LuoxTwo}
      descriptions={[description]}
      headerContent={<HeaderContent logo={<LuoxEnergyIconSvg />} />}
      footerContent={<FooterContent extensionState={extensionState} hasActiveTariff={hasActiveTariff} />}
      onClose={onClose}
      place={place}
      open={true}
      category={{ name: 'dynamic-energy-tariff', paletteColor: theme.palette.secondary }}
      contractStateProps={contractStateProps}
    />
  )
}

export default LuoxDynamicTariffDetails
